import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { useRouteParams } from '../hooks/useRouteParams';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';

const fetchDisclosures = async (clientId: string, draftId: string): Promise<string[]> => {
  return authFetch(
    urlWithParams('/Consumer/ManagedAccounts/Disclosures', { clientId, managedAccountId: draftId }),
  );
};

export const useDisclosuresQuery = () => {
  const { clientId, draftId } = useRouteParams();

  return useQuery(
    queryKeys.disclosures(clientId, draftId),

    () => fetchDisclosures(clientId, draftId),
  );
};
